module.exports = __webpack_public_path__ + "static/parteposterior-5ec750d87a85448252f9baf836c6ee18.webp";